import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7508 11.25C12.7508 11.25 12.9154 4.25646 15.5016 1.67025C17.5824 -0.410578 20.798 -0.568718 22.6837 1.31704C24.5695 3.20279 24.4113 6.4183 22.3305 8.4992C19.7443 11.0854 12.7508 11.25 12.7508 11.25ZM11.2504 11.25C11.2504 11.25 11.0858 4.25646 8.49954 1.67026C6.41871 -0.410568 3.20316 -0.568708 1.3174 1.31704C-0.568351 3.20279 -0.410208 6.4183 1.67063 8.4992C4.25683 11.0854 11.2504 11.25 11.2504 11.25ZM8.49917 22.3302C11.0854 19.744 11.25 12.7505 11.25 12.7505C11.25 12.7505 4.25646 12.9151 1.67026 15.5013C-0.410575 17.5821 -0.568718 20.7977 1.31704 22.6834C3.20279 24.5692 6.41834 24.411 8.49917 22.3302ZM12.7515 12.7505C12.7515 12.7505 12.9161 19.744 15.5023 22.3302C17.5832 24.411 20.7987 24.5692 22.6845 22.6834C24.5702 20.7977 24.4121 17.5821 22.3312 15.5013C19.745 12.9151 12.7515 12.7505 12.7515 12.7505Z"
      fill="#11181C"
    />
  </svg>
)
